<app-page-heading [key]="'realtime-tracking.load-tracking-map.page-title'"
                  [subheadingIcon]="'fa-fw fa fa-globe'"
                  [subheadingLabelKey]="'realtime-tracking.common.timezone'"
                  [disableMarginBottom]="true"
                  [carriers]="carriers" [(selectedCarrier)]="selectedCarrier"
                  [regions]="regions" [(selectedRegion)]="selectedRegion"
                  [timeZone]="true"
                  [timeZonesOptions]="timeZoneService.options"
                  [(selectedTimeZone)]="timeZoneService.selectedTimeZone"
                  (selectedTimeZoneChange)="timeZoneService.selectedTimeZoneChange($event)"
                  [subInfoLabelKey]="overviewActive ? null : (timeZoneService.displayTripTimezone ? 'realtime-tracking.common.trip-timezone': 'realtime-tracking.common.selected-timezone')">
</app-page-heading>

<div class="main-content">
    <app-load-tracking-bucket *ngIf="!singleTrip"
                              [class.hidden]="!showBucket"
                              [carrier]="selectedCarrier"
                              [region]="selectedRegion"
                              [trips]="bucketTrips"
                              [displayableResults]="!overviewActive"
                              [(selectedTrip)]="selectedTrip"
                              [(quickFilter)]="quickFilter"
                              [(scrolled)]="tripsScrolled"
                              [(sort)]="sort"
                              [(sortDirection)]="sortDirection"
                              [(statusSortDirection)]="statusSortDirection"
                              (onTripRemoval)="removeTrip($event)"
                              (onClearBucket)="clearTrips()"
                              (onAddToBucket)="addTripsToBucket($event)"
                              (hideEmitter)="hideBucket()">
    </app-load-tracking-bucket>

    <app-load-tracking-overview *ngIf="overviewActive"
                                [bucketTrips]="bucketTrips"
                                [(selectedTrip)]="selectedTrip"
                                [stats]="stats"
                                [(date)]="date"
                                [(showBucket)]="showBucket"
                                [quickFilter]="quickFilter"
                                [(sort)]="sort"
                                [(sortDirection)]="sortDirection"
                                [(statusSortDirection)]="statusSortDirection"
                                (switcher)="switchMode()"
                                (unselectTrip)="unselectTrip()"
                                (scrolled)="tripsScrolled = true"
                                (quickFilterChange)="setBucketTab($event)">
    </app-load-tracking-overview>

    <app-load-tracking-map *ngIf="!overviewActive"
                           [carrier]="selectedCarrier"
                           [bucketTrips]="bucketTrips"
                           [(selectedTrip)]="selectedTrip"
                           [(showBucket)]="showBucket"
                           [(showAchievedPath)]="showAchievedPath"
                           [(showForecastPath)]="showForecastPath"
                           [canShowDebug]="canShowDebug"
                           [singleTrip]="singleTrip"
                           [(distanceUnit)]="distanceUnit"
                           [forecastPathReady]="forecastPathReady"
                           (switcher)="switchMode()"
                           (centerChangedEmitter)="centerChanged($event)"
                           (goToEmitter)="goToMarker($event)"
                           (centerViewEmitter)="centerView()"
                           (mapReady)="onMapReady($event)"
                           (refreshEmitter)="forceRefreshTripDetails(selectedTrip)"
                           (zoomEmitter)="zoomChanged($event)">
    </app-load-tracking-map>
</div>

